import Feedbacks from '@/api/feedback'

export default {
  save: ({ commit }, { id, data }) => {
    commit('updateItem', { item: { id, loading: true } })
    return Feedbacks.save({ id, data })
      .then(({ data }) => commit('replaceItem', { item: data }))
      .catch(_ => commit('updateItem', { id, loading: false }))
  },
  accept: ({ commit }, { id }) => {
    commit('updateItem', { item: { id, loading: true } })
    return Feedbacks.accept({ id })
      .then(({ data }) => commit('replaceItem', { item: data }))
      .catch(_ => commit('updateItem', { id, loading: false }))
  },
  reject: ({ commit }, { id }) => {
    commit('updateItem', { item: { id, loading: true } })
    return Feedbacks.reject({ id })
      .then(({ data }) => commit('replaceItem', { item: data }))
      .catch(_ => commit('updateItem', { id, loading: false }))
  },
  fetchPerPage: ({ commit }, { page = 1, status = 'pending' }) => {
    commit('changeLoading', { isLoading: true })
    return Feedbacks.fetchAll({ page, status })
      .then(({ data, pagination }) => {
        commit('collectionForPageFetched', {
          collectionForPage: data,
          pagination,
          scope: {
            page,
            status
          }
        })
        commit('changeLoading', { isLoading: false })
      })
      .catch(error => {
        commit('feedbacksError', { error: error.response ? error.response.data.error : error.message })
        commit('changeLoading', { isLoading: false })
        throw error
      })
  }
}



// WEBPACK FOOTER //
// ./src/store/skiliko/feedbacks/actions.js